// extracted by mini-css-extract-plugin
export default {"LoadText":"loadText_LoadText__MNf3j","Light":"loadText_Light__ghCVW"};